<!-- <p>{{dataSource | json}}</p> -->
<div class="table-container">
  <table
    mat-table
    [dataSource]="dataSource"
    class="mat-elevation-z8 responsive-table"
  >
    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">
        <p
          class="assessment-core-test-title"
          *ngIf="!element.description"
          [matTooltip]="element.name"
        >
          {{ element.name }}
        </p>
        <p
          class="assessment-sub-test-title"
          *ngIf="element.description"
          [matTooltip]="element.name"
        >
          {{ element.name }}
        </p>
        <p
          class="assessment-sub-test-description"
          *ngIf="element.description"
          [matTooltip]="element.description"
        >
          {{ element.description }}
        </p>
      </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="RawScore">
      <th mat-header-cell *matHeaderCellDef>RawScore</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="!element.isCore">
          {{ element.rawScore }}
        </ng-container>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="Score">
      <th mat-header-cell *matHeaderCellDef>Score</th>
      <td mat-cell *matCellDef="let element">{{ element.score }}</td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="PercentileRank">
      <th mat-header-cell *matHeaderCellDef>PercentileRank</th>
      <td mat-cell *matCellDef="let element">
        {{ element.percentileRank }}{{ element?.percentileRank ? '%' : '' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Level">
      <th mat-header-cell *matHeaderCellDef>Level</th>
      <td
        mat-cell
        *matCellDef="let element"
        [matTooltip]="element.levelItem?.name"
      >
        {{ element.levelItem?.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Action" *ngIf="!isView" stickyEnd>
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          *ngIf="element.score === undefined || element.score === null"
          (click)="onAddClick($event, element, i)"
          height="18px"
          viewBox="0 -960 960 960"
          width="18px"
          fill="#f2893e"
          role="button"
          [aria-label]="'Add Score' | translate"
          [matTooltip]="'Add Score' | translate"
        >
          <path
            d="M440-440H240q-17 0-28.5-11.5T200-480q0-17 11.5-28.5T240-520h200v-200q0-17 11.5-28.5T480-760q17 0 28.5 11.5T520-720v200h200q17 0 28.5 11.5T760-480q0 17-11.5 28.5T720-440H520v200q0 17-11.5 28.5T480-200q-17 0-28.5-11.5T440-240v-200Z"
          />
        </svg>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          *ngIf="element.score !== undefined && element.score !== null"
          (click)="onEditClick($event, element, i)"
          height="18px"
          viewBox="0 -960 960 960"
          width="18px"
          fill="#f2893e"
          role="button"
          aria-label="Edit Score"
          [matTooltip]="'Edit Score'"
        >
          <path
            d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h261q20 0 30 12.5t10 27.5q0 15-10.5 27.5T460-760H200v560h560v-261q0-20 12.5-30t27.5-10q15 0 27.5 10t12.5 30v261q0 33-23.5 56.5T760-120H200Zm280-360Zm-120 80v-97q0-16 6-30.5t17-25.5l344-344q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L553-384q-11 11-25.5 17.5T497-360h-97q-17 0-28.5-11.5T360-400Zm481-384-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z"
          />
        </svg>
      </td>
    </ng-container>
    <ng-container>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns; when: isRegularRow"
      ></tr>
    </ng-container>

    <!-- Group header -->
    <ng-container matColumnDef="GroupName">
      <td mat-cell *matCellDef="let groupBy" class="group-name-header">
        <strong [matTooltip]="groupBy.groupName | translate">{{
          groupBy.groupName | translate
        }}</strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="HeadingColumn1">
      <td mat-cell *matCellDef="let groupBy" class="header-style-raw">
        <ng-container *ngIf="!groupBy.isCore">
          <strong [matTooltip]="groupBy.headingColumn1 | translate">
            {{ groupBy.headingColumn1 | translate }}
          </strong>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="HeadingColumn2">
      <td mat-cell *matCellDef="let groupBy" class="header-style-score">
        <strong [matTooltip]="groupBy.headingColumn2 | translate">{{
          groupBy.headingColumn2 | translate
        }}</strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="HeadingColumn3">
      <td mat-cell *matCellDef="let groupBy" class="header-style-percentile">
        <strong [matTooltip]="groupBy.headingColumn3 | translate">{{
          groupBy.headingColumn3 | translate
        }}</strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="HeadingColumn4">
      <td mat-cell *matCellDef="let groupBy" class="header-style-level">
        <strong [matTooltip]="groupBy.headingColumn4 | translate">{{
          groupBy.headingColumn4 | translate
        }}</strong>
      </td>
    </ng-container>
    <ng-container matColumnDef="HeadingColumn5" *ngIf="!isView" stickyEnd>
      <td mat-cell *matCellDef="let groupBy" class="header-style-action">
        <strong [matTooltip]="'Action' | translate"> </strong>
      </td>
    </ng-container>

    <ng-container>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedHeaders; when: isGroup"
        class="assessment-header-row"
      ></tr>
    </ng-container>
  </table>
</div>
